<template>
    <v-btn v-if="!isGuest"
           ref="fix-blue-light-button"
           v-tippy
           content="Fix Blue Light Artifacts - LEGACY"
           :disabled="!canUseColorGradingTools || !image"
           @click="onClick"
    >
        <v-icon class="material-icons">wb_iridescent</v-icon>
    </v-btn>
</template>

<script>
import CanMixin from "@/mixins/CanMixin";
import { mapGetters, mapState } from "vuex";
import $ from "jquery";

export default {
    mixins: [CanMixin],
    computed: {
        ...mapState('Projects', ['image']),
        ...mapState('Scopes', ['scopesEnabled']),
        ...mapGetters('User', ['isGuest']),
    },
    mounted() {
        this.$root.$refs.fixBlueLightButton = this.$refs["fix-blue-light-button"];
    },
    methods: {
        onClick(e) {
            lutify.fixBlueLightArtifacts = !lutify.fixBlueLightArtifacts;
            $(e.currentTarget).toggleClass("v-btn--active");
            gpu.updateIDT(lutify.selectedIDT, false);

            if (lutify.fixBlueLightArtifacts && lutify.gamutCompress) {
                this.$nextTick(() => {
                    this.$root.$refs.gamutCompressButton.$el.click();
                })}
        }
    }
}
</script>